import { useLocation } from "react-router-dom";
import { isDevHostname } from "../config/platform";

const PLATFORM_DOMAIN = process.env.REACT_APP_PLATFORM_DOMAIN || "partyrentalsuite.com";

export function isSubdomain() {
  const host = window.location.hostname.toLowerCase();
  const platform = PLATFORM_DOMAIN.toLowerCase();
  if (isDevHostname(host)) return false;
  if (host.endsWith(`.${platform}`)) {
    const prefix = host.slice(0, -(platform.length + 1));
    if (prefix && prefix !== "www" && prefix !== "app") return true;
  }
  return false;
}

/**
 * useThemeBase — returns the base path for theme links, INCLUDING the
 * /es language prefix when the customer is on the Spanish version.
 * On tenant subdomain (production):   "" or "/es"
 * On /s/{subdomain} route (preview):  "/s/{sub}" or "/s/{sub}/es"
 * On /preview-{theme} route (demo):   "/preview-bounce" or "/preview-bounce/es"
 */
export function useThemeBase() {
  const { pathname } = useLocation();
  let base = "";

  if (isSubdomain()) {
    base = "";
  } else {
    const siteMatch = pathname.match(/^(\/s\/[^/]+)/);
    if (siteMatch) base = siteMatch[1];
    else {
      const previewMatch = pathname.match(/^(\/preview-[a-z-]+)/);
      base = previewMatch ? previewMatch[1] : "/preview-bounce";
    }
  }

  // Detect /es prefix immediately after the site base
  const afterBase = pathname.slice(base.length);
  if (afterBase === "/es" || afterBase.startsWith("/es/")) {
    return `${base}/es`;
  }
  return base;
}

/** useThemeBaseRoot — same as useThemeBase but ALWAYS without the /es prefix.
 *  Useful when building language-switcher links. */
export function useThemeBaseRoot() {
  const { pathname } = useLocation();
  if (isSubdomain()) return "";
  const siteMatch = pathname.match(/^(\/s\/[^/]+)/);
  if (siteMatch) return siteMatch[1];
  const previewMatch = pathname.match(/^(\/preview-[a-z-]+)/);
  return previewMatch ? previewMatch[1] : "/preview-bounce";
}
